import Template from "../app/Template";
import { useAppDispatch, useAppSelector } from "../../hooks";
import Card from "../layout/Card";
import CardWithImageBgAndBadgeTop from "../layout/CardWithImageBgAndBadgeTop";
import BecomeAMember from "../landing/BecomeAMember";
import { useEffect } from "react";
import { getCategoryTopics } from "../../slices/category";
import { getCollections } from "../../slices/content";
import { Topic } from "../../types/category";


export default function TopicsAndCollections() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getCategoryTopics({ pageNumber: 1, query: null }));
    dispatch(getCollections({ pageNumber: 1, query: null }));
  }, []);

  // Get app level state from redux store
  const { loading: authLoading } = useAppSelector((state) => state.auth);
  const {
    collections: { data: collectionData, loading: collectionLoading },
  } = useAppSelector((state) => state.content);
  const {
    topics: { data: topicsData, loading: topicsLoading },
  } = useAppSelector((state) => state.category);

  // Constant variables
  const exploreTopicsAndCollections: Array<{ id: string; type: "Topic" | "Collection"; name: string; image: string | null; slug: null | string }> = [];
  topicsData.forEach((topic: Topic) => exploreTopicsAndCollections.push({
    id: topic.id,
    type: "Topic",
    name: topic.name,
    image: topic.image,
    slug: topic.slug
  }));
  collectionData.forEach((collection: any) => exploreTopicsAndCollections.push({
    id: collection.id,
    type: "Collection",
    name: collection.name,
    image: collection.images.length > 0 ? collection.images[0] : null,
    slug: collection.slug
  }));

  // Sort them alphabetically
  exploreTopicsAndCollections.sort((a, b) => a.name.localeCompare(b.name));

  return (
    <Template navbarMode="solid">

      <div className="grid grid-col-1 gap-y-20 mb-20">
        {/* Hero */}
        <div>
          <div
            className="mt-24 sm:mt-28 md:mt-40 flex items-center justify-center w-4/5 mx-auto bg-off-white"
          >
            <Card colour="yellow" className="w-full grid grid-cols-1 gap-y-4 relative" paddingX="px-8 sm:px-16" paddingY="py-8 sm:py-16">
              <h1 className="text-dark-grey text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold">Explore Topics & Collections</h1>
              <p className="text-dark-grey text-sm sm:text-base md:text-lg lg:text-xl">From ADHD to Autism, school to workplace - explore by topic or dive into a themed collection. Each page brings together valuable insights, tools, and support. More coming soon!</p>

              {/* Bubbles */}
              <img
                src="/img/graphics/bubbles/bubble-top-orange.svg"
                alt="Bubble"
                className="absolute w-24 object-cover top-20 -right-12 z-0"
              />
              <img
                src="/img/graphics/bubbles/bubble-right-blue.svg"
                alt="Bubble"
                className="absolute w-32 md:w-44 object-cover -bottom-8 right-12 z-0"
              />
            </Card>
          </div>

        </div>

        {/* Topic and Collections */}
        <div
          className="flex items-center justify-center w-9/10 lg:w-4/5 mx-auto"
        >
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 sm:gap-6 w-full justify-items-stretch">
            {exploreTopicsAndCollections.map((content, index) => {
              return (
                // <a className="flex justify-center items-center" target="_blank" rel="noreferrer" href={content.type === "Collection" ? `/collection/${content.name}` : `/topic/${content.name}`} key={`explore-${index}`}>
                <CardWithImageBgAndBadgeTop
                  objectId={content.id}
                  objectType={content.type}
                  showFavouriteButton={true}
                  key={`explore-${index}`}
                  colour={content.type === "Topic" ? "yellow" : "mint-green"}
                  image={content.image === null ? "/img/graphics/hero/landing-hero.png" : content.image}
                  href={content.type === "Collection" ? `/collection/${content.slug}` : `/topic/${content.slug}`}
                  badgeText={content.type}
                  cardText={content.name}
                  newTab={true}
                  // Fill the grid cell instead of the carousel's fixed 200px, and
                  // keep the card's portrait proportions as the column grows.
                  sizeClass="w-full aspect-[2/3] min-h-[250px]"
                />
                // </a>
              )
            })}
          </div>
        </div>

        {/* Become a member */}
        <BecomeAMember />

      </div>

    </Template>
  );
}
